<template>
  <v-list-item
    class="project-list-item"
    :class="classObject"
    style="cursor:pointer"
  >
    <v-list-item-content class="py-0">
      <router-link
        exact
        class="list-item-link fill-height px-4"
        :class="isActive ? 'py-4' : 'py-1'"
        :to="{ name: 'project_detail', params: { id: project.id } }"
      >
        <v-list-item-title>
          <template v-if="isEditing">
            <v-text-field
              v-model="editingTitle"
              dense
              solo
              autofocus
              outlined
              hide-details
              @keyup.enter="confirmRename"
              @keyup.esc="cancelRename"
              @click.prevent
            />
            <div class="d-flex mt-1">
              <v-btn x-small text color="success" @click.prevent="confirmRename">
                <v-icon x-small>mdi-check</v-icon>
              </v-btn>
              <v-btn x-small text color="error" @click.prevent="cancelRename">
                <v-icon x-small>mdi-close</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-else-if="isConfirmingDelete">
            <span class="white--text">Supprimer ce projet ?</span>
            <div class="d-flex mt-1">
              <v-btn x-small color="white" text @click.prevent="confirmDelete">
                <v-icon x-small>mdi-check</v-icon>
              </v-btn>
              <v-btn x-small text @click.prevent="cancelDelete">
                <v-icon x-small>mdi-close</v-icon>
              </v-btn>
            </div>
          </template>
          <span v-else class="d-flex align-center">
            {{ project.title || project.initial_message }}
          </span>
        </v-list-item-title>
      </router-link>
    </v-list-item-content>

    <v-list-item-action>
      <v-menu v-model="menuOpen" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small @click.stop class="caption" v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click.stop="startRename">
            <v-list-item-title>
              <v-icon class="mr-2" small>mdi-pencil</v-icon>
              Renommer
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="error--text" @click.stop="startDelete">
            <v-list-item-title>
              <v-icon class="mr-2" color="error" small>mdi-delete</v-icon>
              Supprimer
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'ProjectListItem',
  props: {
    project: {
      type: Object,
      required: true,
    },
    currentId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      menuOpen: false,
      isEditing: false,
      editingTitle: '',
      isConfirmingDelete: false,
    }
  },
  methods: {
    startRename() {
      this.editingTitle = this.project.title || this.project.initial_message || ''
      this.menuOpen = false
      this.isEditing = true
    },
    confirmRename() {
      this.isEditing = false
      this.$store.dispatch('project/renameProject', { id: this.project.id, title: this.editingTitle })
    },
    cancelRename() {
      this.isEditing = false
      this.editingTitle = ''
    },
    startDelete() {
      this.menuOpen = false
      this.isConfirmingDelete = true
    },
    confirmDelete() {
      this.isConfirmingDelete = false
      this.$store.dispatch('project/deleteProject', this.project.id)
    },
    cancelDelete() {
      this.isConfirmingDelete = false
    },
  },
  computed: {
    p () {
      return this.project
    },
    isActive () {
      return this.p.id === this.currentId && this.$route.name == 'project_detail'
    },
    classObject () {
      if (this.isConfirmingDelete)
          return 'error'
      if (this.isActive)
        return `${this.$theme.layout.activeItemColor} white--text is-active`
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item-link {
  display: block;
  text-decoration: none;
  color: inherit;
}

.project-list-item {
  // Inactive rows are compact: override Vuetify's 40px dense minimum.
  &:not(.is-active):not(.error) {
    min-height: 32px;
    .v-list-item__action {
      margin-top: 0;
      margin-bottom: 0;
    }
    .v-list-item__content {
      min-height: 0;
    }
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .caption {
    visibility: hidden;
  }
  &.is-active .caption .v-icon {
    color: white;
  }
  &:hover .caption {
    visibility: visible;
  }
}
</style>
